__turbopack_context__.v({
  "channel_button": "Channel-module-scss-module__s8mxzG__channel_button",
  "channel_button__container": "Channel-module-scss-module__s8mxzG__channel_button__container",
  "channel_button__logo": "Channel-module-scss-module__s8mxzG__channel_button__logo",
  "channel_button__selected": "Channel-module-scss-module__s8mxzG__channel_button__selected",
  "channel_button__text": "Channel-module-scss-module__s8mxzG__channel_button__text",
  "multi_livestream__schedule__channel": "Channel-module-scss-module__s8mxzG__multi_livestream__schedule__channel",
  "multi_livestream__schedule__channel__listings": "Channel-module-scss-module__s8mxzG__multi_livestream__schedule__channel__listings",
});
